var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72125 9L2.4525 5.67237L0 3.43421L3.24 3.13816L4.5 0L5.76 3.13816L9 3.43421L6.5475 5.67237L7.27875 9L4.5 7.23553L1.72125 9Z",
    fill: "#2259D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarBlue);
export default __webpack_public_path__ + "static/media/icon_star_blue.f484dbebf23325d536134d49f8ae1604.svg";
export { ForwardRef as ReactComponent };